import t from "react";
import o from "classnames";
import { T as a } from "./index-Dd-4N6BE.es.js";
import './Body2.css';const m = "Body-module__lineClamp___B1Oty", s = {
  lineClamp: m
}, c = ({
  children: l,
  maxLines: e
}) => /* @__PURE__ */ t.createElement(a.Body2, { tagName: "p", responsive: !0 }, /* @__PURE__ */ t.createElement(
  "span",
  {
    className: o(e && s.lineClamp),
    style: e ? { WebkitLineClamp: e } : {}
  },
  l
));
export {
  c as B
};
